import Vue from 'vue';
import Router from 'vue-router';
import App from './App';

let appElement = document.getElementById('app');
if(appElement) {
    Vue.use(Router);
}

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/:step',
            component: App
        },
    ]
})
